import {useMediaQuery} from 'hooks/useMediaQuery';
import {breakpoints} from 'lib/breakpoints';
import {FC} from 'react';

import {Skeleton} from 'components/Skeleton/Skeleton';
import {SkeletonLoadingOverlay} from 'components/Skeleton/SkeletonOverlay/SkeletonOverlay';

import styles from './OrderSuccess.module.css';

type Props = {};
export const OrderSuccessSkeleton: FC<Props> = () => {
    const isDesktop = useMediaQuery(breakpoints.up('mmd'));

    return (
        <div className={styles.blockSkeleton}>
            <div className={styles.main}>
                <div className={styles.content}>
                    <div className={styles.info}>
                        <SkeletonLoadingOverlay>
                            <Skeleton className={styles.infoSkeleton} />
                        </SkeletonLoadingOverlay>
                    </div>
                    {!isDesktop && (
                        <SkeletonLoadingOverlay>
                            <Skeleton className={styles.sidebarSkeleton} />
                        </SkeletonLoadingOverlay>
                    )}

                    <div className={styles.orderedProducts}>
                        <SkeletonLoadingOverlay>
                            <Skeleton
                                className={styles.orderedProductsSkeleton}
                            />
                        </SkeletonLoadingOverlay>
                    </div>
                </div>

                {isDesktop && (
                    <SkeletonLoadingOverlay>
                        <Skeleton className={styles.sidebarSkeleton} />
                    </SkeletonLoadingOverlay>
                )}
            </div>
        </div>
    );
};
